import { getQuantityFromUrl } from "./urlHelper";
import { Quantities } from "../types/ContentfulTypes";

export default class Quantity {
  // Default quantity is defined as the first value found in the following order.
  // 1. Quantity override from `qty` query string param
  // 2. MSX default quantity
  // 3. MSX recommended quantity
  // 4. First quantity in quantity list (if the list is defined)
  static getDefaultQuantity(
    msxDefaultQty: number | undefined,
    msxRecommendedQty: number | undefined,
    validQuantities?: number[]
  ) {
    if (validQuantities && validQuantities.length <= 0) {
      console.log("Quantities are not defined; defaulting to quantity 1.");
      return 1;
    }

    let defaultQuantity = msxDefaultQty || msxRecommendedQty || validQuantities?.[0] || 1;

    // Use query quantity override if there is any
    const queryQty = getQuantityFromUrl();
    if (queryQty && (!validQuantities || validQuantities.includes(queryQty))) {
      defaultQuantity = queryQty;
    }

    return defaultQuantity;
  }

  static getRecommendedQuantity(mpvQuantities: Quantities) {
    return mpvQuantities?.recommended || -1;
  }
}
